import toast from "react-hot-toast";
import { formatPatrolHotspotApiResponseBody } from "./patrolAssetHotspotContent";
import {
  PATROL_API_URL_GREEN_ICON,
  PATROL_API_URL_RED_ICON,
  PATROL_API_URL_YELLOW_ICON,
} from "./patrolHotspotIcons.js";
import {
  PATROL_API_URL_BUTTON_GAP_PX,
  PATROL_API_URL_BUTTON_SIZE_PX,
} from "./patrolHotspotMarkerDom.js";
import { API_URL_HOTSPOT_LANE_LABELS } from "../../../api/cameraHotspots.ts";
import {
  getApiUrlHotspotLaneUrl,
  getConfiguredApiUrlHotspotLanes,
  parseApiUrlHotspotContent,
} from "../../../api/cameraHotspots.ts";

export const PATROL_API_URL_BUTTON_SIZE = PATROL_API_URL_BUTTON_SIZE_PX;
export const PATROL_API_URL_BUTTON_GAP = PATROL_API_URL_BUTTON_GAP_PX;

/**
 * @param {number} laneCount
 */
export function patrolApiUrlMarkerWidth(laneCount) {
  const n = Math.max(0, Number(laneCount) || 0);
  if (n <= 0) return PATROL_API_URL_BUTTON_SIZE;
  return (
    n * PATROL_API_URL_BUTTON_SIZE + (n - 1) * PATROL_API_URL_BUTTON_GAP
  );
}

export {
  PATROL_API_URL_GREEN_ICON,
  PATROL_API_URL_RED_ICON,
  PATROL_API_URL_YELLOW_ICON,
  parseApiUrlHotspotContent,
  getApiUrlHotspotLaneUrl,
  getConfiguredApiUrlHotspotLanes,
};

/**
 * @param {string} url
 */
export async function callPatrolHotspotApiUrl(url) {
  const target = String(url ?? "").trim();
  if (!target) {
    throw new Error("API URL is not configured.");
  }

  const res = await fetch(target, {
    method: "GET",
    headers: { Accept: "application/json, text/plain, */*" },
  });
  const text = await res.text();
  const body = formatPatrolHotspotApiResponseBody(
    text,
    res.headers.get("content-type"),
  );

  if (!res.ok) {
    const err = new Error(`Request failed (${res.status}).`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return { status: res.status, body };
}

/**
 * @param {string} url
 * @param {string} label Display label (e.g. Green, Red, Yellow)
 */
export async function triggerPatrolApiUrlHotspotUrl(url, label, contentUrl = "") {
  const target = String(url ?? "").trim();
  if (!target) {
    toast.error(
      `${label} API URL is not configured. Open Camera management → edit this hotspot → add the ${label} URL → Save.`,
    );
    throw new Error(`${label} API not configured`);
  }

  try {
    return await callPatrolHotspotApiUrl(target);
  } catch (e) {
    toast.error(
      e instanceof Error ? e.message : `Could not call ${label.toLowerCase()} API.`,
    );
    throw e;
  }
}

/**
 * @param {string} contentUrl
 * @param {"green" | "red" | "yellow"} lane
 */
export async function triggerPatrolApiUrlHotspot(contentUrl, lane) {
  const url = getApiUrlHotspotLaneUrl(contentUrl, lane);
  const label = API_URL_HOTSPOT_LANE_LABELS[lane] ?? lane;
  return triggerPatrolApiUrlHotspotUrl(url, label, contentUrl);
}
